import React from "react";
import documentsIllustrationLogo from "./DocumentsIllustrationLogo.svg";

function DocumentsIllustrationLogoIcon({
  alt = "Documents illustration",
  className = "",
  height = 172,
  width = 300,
}) {
  return (
    <img
      alt={alt}
      className={className}
      height={height}
      src={documentsIllustrationLogo}
      width={width}
    />
  );
}

export default DocumentsIllustrationLogoIcon;
